import React from 'react';
import { motion } from 'framer-motion';

// Components
import Hero from '../components/home/Hero';
import Services from '../components/home/Services';
import Location from '../components/home/Location';
import Partners from '../components/home/Partners';
import AboutUs from '../components/home/AboutUs';

const Home = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Hero />
      <Partners />
      <Services />
      <AboutUs />
      <Location />
    </motion.div>
  );
};

export default Home;